<template>
  <div class="bg-gray-50 text-textMain min-h-screen flex flex-col">
    <!-- 浮动按钮 -->
    <div class="float-btn feedback-btn" style="bottom: 120px;" @click="feedbackOpen = true">
      <i class="fa-solid fa-comment-dots"></i>
    </div>
    <div class="float-btn email-btn" style="bottom: 180px;" @click="emailModalVisible = true">
      <i class="fa-solid fa-envelope"></i>
    </div>

    <!-- 反馈面板 -->
    <div class="feedback-panel" :class="{ open: feedbackOpen }">
      <div class="p-6 h-full flex flex-col">
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-xl font-semibold">问题反馈</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="feedbackOpen = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <form class="flex-1 flex flex-col gap-4">
          <div>
            <label class="block text-textSub mb-2">问题类型</label>
            <select v-model="feedbackType" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200 text-textSub">
              <option value="">请选择问题类型</option>
              <option value="function">功能异常</option>
              <option value="experience">体验问题</option>
              <option value="suggest">功能建议</option>
              <option value="other">其他问题</option>
            </select>
          </div>
          <div>
            <label class="block text-textSub mb-2">问题描述</label>
            <textarea v-model="feedbackDesc" class="w-full bg-white rounded-md p-3 resize-y min-h-[150px] focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" placeholder="请详细描述您遇到的问题..."></textarea>
          </div>
          <div>
            <label class="block text-textSub mb-2">联系方式</label>
            <input v-model="feedbackContact" type="text" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" placeholder="手机号/微信/邮箱（便于回复）">
          </div>
          <button
            type="button"
            class="mt-4 bg-primary text-white py-3 rounded-md btn-hover"
            :disabled="feedbackLoading"
            @click="handleSubmitFeedback"
          >
            {{ feedbackLoading ? '提交中...' : '提交反馈' }}
          </button>
        </form>
      </div>
    </div>

    <!-- 邮箱弹窗 -->
    <BaseModal :visible="emailModalVisible" title="联系我们" maxWidth="sm" @close="emailModalVisible = false">
      <p class="text-center text-xl mb-6 text-primary">help@jianshu.com</p>
      <template #footer>
        <button class="w-full bg-primary text-white py-2 rounded-md btn-hover" @click="emailModalVisible = false">确定</button>
      </template>
    </BaseModal>

    <AppHeader
      :current-section="currentSection"
      :is-logged-in="isLoggedIn"
      :nickname="nickname"
      :avatar="avatar"
      :balance-points="balancePoints"
      @nav="handleNav"
      @login="handleLoginClick"
      @logout="handleLogout"
    />

    <main class="flex-1 max-w-7xl mx-auto w-full px-4 py-6 md:px-6 md:py-8">
      <ShortNovel v-show="currentSection === 'short-novel'" :active="currentSection === 'short-novel'" @show-modal="showModal" @copy="copyContent" />
      <LongNovel v-show="currentSection === 'long-novel'" @show-modal="showModal" @copy="copyContent" />
      <CoreIdea v-show="currentSection === 'coreIdea'" :active="currentSection === 'coreIdea'" @show-modal="showModal" @copy="copyContent" />
      <OutlineSection v-show="currentSection === 'outline'" :active="currentSection === 'outline'" @show-modal="showModal" @copy="copyContent" />
      <CoverSection v-show="currentSection === 'cover'" :active="currentSection === 'cover'" @show-modal="showModal" />
      <VipRecharge
        ref="vipRecharge"
        v-show="currentSection === 'vip-recharge'"
        :active="currentSection === 'vip-recharge'"
        @show-modal="showModal"
        @show-pay-modal="showPayModal"
      />
      <ProfileSection
        ref="profile"
        v-show="currentSection === 'profile'"
        :active="currentSection === 'profile'"
        :work-data="workData"
        @nav="currentSection = $event"
        @open-view-all="openViewAll"
        @show-modal="showModal"
        @copy="copyContent"
        @open-full="openFullContent"
        @cancel-account="handleCancelAccount"
      />
      <MyNovels
        ref="myNovels"
        v-show="currentSection === 'my-novels'"
        :active="currentSection === 'my-novels'"
        @show-modal="showModal"
        @save-work-edit="handleSaveWorkEdit"
      />
      <ConsumeRecord
        ref="consumeRecord"
        v-show="currentSection === 'consume-record'"
        :active="currentSection === 'consume-record'"
      />
    </main>

    <!-- 账户注销成功弹窗（点击确定刷新页面） -->
    <div v-show="cancelAccountResult.visible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg mx-4">
        <h3 class="text-xl font-semibold mb-4">提示</h3>
        <p class="mb-6 text-textSub">{{ cancelAccountResult.message }}</p>
        <button class="w-full bg-primary text-white py-2 rounded-md btn-hover" @click="cancelAccountResult.visible = false; location.reload()">确定</button>
      </div>
    </div>

    <!-- 通用弹窗 -->
    <BaseModal :visible="modal.visible" :title="modal.title" maxWidth="sm" @close="closeModal">
      <p class="mb-6 text-textSub whitespace-pre-line">{{ modal.message }}</p>
      <template #footer>
        <button class="w-full bg-primary text-white py-2 rounded-md btn-hover" @click="handleModalConfirm">确定</button>
      </template>
    </BaseModal>

    <!-- 支付弹窗 -->
    <div v-show="payModal.visible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="payModal.visible = false">
      <div class="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">{{ payModal.title }}</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="payModal.visible = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <p class="mb-6 text-textSub" v-html="payModal.message"></p>
        <div class="flex gap-3">
          <button
            class="flex-1 bg-primary text-white py-2 rounded-md btn-hover"
            :disabled="payLoading"
            @click="handlePay"
          >
            {{ payLoading ? '支付中...' : '支付' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 支付结果弹窗 -->
    <div v-show="payResultModal.visible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="closePayResultModal">
      <div class="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">{{ payResultModal.title }}</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="closePayResultModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <p class="mb-6 text-textSub whitespace-pre-line">{{ payResultModal.message }}</p>
        <div v-if="wechatCodeQrDataUrl" class="flex justify-center mb-6">
          <img :src="wechatCodeQrDataUrl" alt="微信支付二维码" class="w-52 h-52">
        </div>
        <button
          class="w-full bg-primary text-white py-2 rounded-md btn-hover"
          :disabled="payResultLoading"
          @click="handlePayResultConfirm"
        >
          {{ payResultLoading ? '查询中...' : '已经支付成功' }}
        </button>
      </div>
    </div>

    <!-- 多段会员计划提示弹窗（基于 /api/pay/go 返回） -->
    <div
      v-show="memberPlanModal.visible"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      @click.self="memberPlanModal.visible = false"
    >
      <div class="bg-white rounded-lg p-6 w-full max-w-lg border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg md:text-xl font-semibold text-textMain">
            您的账号存在多段会员计划，生效顺序如下：
          </h3>
          <button class="text-textSub text-xl cursor-pointer" @click="memberPlanModal.visible = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="space-y-3">
          <div
            v-if="memberPlanModal.userExpireDate"
            class="flex items-start bg-gray-50 rounded-md px-4 py-3 border border-gray-200"
          >
            <div class="mr-3 mt-0.5">
              <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary text-white text-xs font-semibold">
                1
              </span>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-1">
                <span class="font-medium text-textMain">
                  当前会员计划
                </span>
                <span class="text-xs px-2 py-0.5 rounded-full bg-gray-200 text-green-500">
                  生效中
                </span>
              </div>
              <p class="text-xs text-textSub">
                到期时间：{{ memberPlanModal.userExpireDate }}
              </p>
            </div>
          </div>
          <div
            v-if="memberPlanModal.toBugExpireDate"
            class="flex items-start bg-gray-50 rounded-md px-4 py-3 border border-gray-200"
          >
            <div class="mr-3 mt-0.5">
              <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary text-white text-xs font-semibold">
                2
              </span>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-1">
                <span class="font-medium text-textMain">
                  月会员
                </span>
                <span class="text-xs px-2 py-0.5 rounded-full bg-gray-200 text-orange-500">
                  购买中
                </span>
              </div>
              <p class="text-xs text-textSub">
                到期时间：{{ memberPlanModal.toBugExpireDate }}
              </p>
            </div>
          </div>
        </div>
        <button
          class="mt-5 w-full bg-primary text-white py-2 rounded-md btn-hover"
          @click="memberPlanModal.visible = false"
        >
          我知道了
        </button>
      </div>
    </div>

    <!-- 全文查看弹窗 -->
    <div v-show="fullContent.visible" class="full-content-modal" @click.self="fullContent.visible = false">
      <div class="modal-box">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">{{ fullContent.title }}</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="fullContent.visible = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="text-textMain whitespace-pre-line">{{ fullContent.body }}</div>
      </div>
    </div>

    <!-- 查看全部弹窗 -->
    <ViewAllModal
      v-if="viewAll.visible"
      :type-name="viewAll.typeName"
      :works="viewAll.works"
      :current-page="viewAll.currentPage"
      :has-more="viewAll.hasMore"
      @close="viewAll.visible = false"
      @copy="copyContent"
      @open-full="handleViewAllOpenFull"
      @show-modal="showModal"
      @prev-page="viewAllChangePage(viewAll.currentPage - 1)"
      @next-page="viewAllChangePage(viewAll.currentPage + 1)"
    />

    <!-- 全局 Toast（挂到 body，不带遮罩） -->
    <GlobalToast :visible="toast.visible" :message="toast.message" :type="toast.type" />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import BaseModal from './components/BaseModal.vue'
import GlobalToast from './components/GlobalToast.vue'
import { copyText } from './utils/clipboard'
import { setMessageHandler } from './utils/message'
import workData from './data/workData.js'
import { checkLogin } from './api/auth.js'
import { resolveLoginGate } from './api/loginGate'
import { cancelAccount, getMemberWorkList } from './api/member.js'
import request from './api/request.js'
import { goPay, queryPayStatus } from './api/pay.js'
import { submitFeedback } from './api/feedback.js'
import { updateWorkTask } from './api/workTask.js'
import QRCode from 'qrcode'
import { PATH_TO_SECTION, SECTION_TO_PATH, DEFAULT_PATH } from './router/index.js'
import { useAuthState, setAuthState } from './store/auth'

/** 从登录用户信息中取头像地址（后端字段名可能为 avatar / avatarUrl / headimg 等） */
function pickUserAvatarUrl (user) {
  if (!user || typeof user !== 'object') return ''
  var keys = ['avatar', 'avatarUrl', 'avatar_url', 'headimg', 'headImg', 'photo', 'portrait']
  for (var i = 0; i < keys.length; i++) {
    var v = user[keys[i]]
    if (v != null && String(v).trim()) return String(v).trim()
  }
  return ''
}

export default {
  name: 'App',
  components: {
    AppHeader,
    BaseModal,
    GlobalToast,
    ShortNovel: () => import(/* webpackChunkName: "short-novel" */ './components/ShortNovel.vue'),
    LongNovel: () => import(/* webpackChunkName: "long-novel" */ './components/LongNovel.vue'),
    CoreIdea: () => import(/* webpackChunkName: "core-idea" */ './components/CoreIdea.vue'),
    OutlineSection: () => import(/* webpackChunkName: "outline-section" */ './components/OutlineSection.vue'),
    CoverSection: () => import(/* webpackChunkName: "cover-section" */ './components/CoverSection.vue'),
    VipRecharge: () => import(/* webpackChunkName: "vip-recharge" */ './components/VipRecharge.vue'),
    ProfileSection: () => import(/* webpackChunkName: "profile-section" */ './components/ProfileSection.vue'),
    MyNovels: () => import(/* webpackChunkName: "my-novels" */ './components/MyNovels.vue'),
    ConsumeRecord: () => import(/* webpackChunkName: "consume-record" */ './components/ConsumeRecord.vue'),
    ViewAllModal: () => import(/* webpackChunkName: "view-all-modal" */ './components/ViewAllModal.vue')
  },
  data () {
    return {
      currentSection: 'short-novel',
      feedbackOpen: false,
      feedbackType: '',
      feedbackDesc: '',
      feedbackContact: '',
      feedbackLoading: false,
      emailModalVisible: false,
      modal: { visible: false, title: '', message: '', onConfirm: null },
      payModal: { visible: false, title: '', message: '', payload: null },
      payResultModal: { visible: false, title: '', message: '' },
      memberPlanModal: { visible: false, userExpireDate: '', toBugExpireDate: '' },
      payResultLoading: false,
      payResultOrderNo: '',
      payType: '',
      wechatCodeQrDataUrl: '',
      payLoading: false,
      toast: { visible: false, message: '', type: 'success', timer: null },
      fullContent: { visible: false, title: '', time: '', body: '' },
      viewAll: { visible: false, typeName: '', works: [], type: '', currentPage: 1, pageSize: 5, hasMore: false },
      cancelAccountResult: { visible: false, message: '' },
      workData
    }
  },
  computed: {
    authState () {
      return useAuthState()
    },
    isLoggedIn () {
      return this.authState.isLoggedIn
    },
    balancePoints () {
      return this.authState.balancePoints
    },
    nickname () {
      return this.authState.nickname || ''
    },
    avatar () {
      return this.authState.avatar || ''
    }
  },
  provide () {
    return {
      showModal: this.showModal,
      copyContent: this.copyContent,
      openFullContent: this.openFullContent,
      openViewAll: this.openViewAll
    }
  },
  watch: {
    currentSection (val) {
      this.loadCurrentSectionData()
    },
    $route (to) {
      const segment = to && to.params && to.params.section
      const section = segment ? PATH_TO_SECTION[segment] : null
      if (section) {
        this.currentSection = section
      }
    }
  },
  mounted () {
    const segment = this.$route && this.$route.params && this.$route.params.section
    const section = segment ? PATH_TO_SECTION[segment] : null
    if (section) {
      this.currentSection = section
    }
    // 全局弹窗/接口错误统一处理（包含业务码 152）
    setMessageHandler((payload) => {
      if (!payload) return
      if (typeof payload === 'string') {
        this.showModal('提示', payload)
        return
      }
      const title = payload.title || '提示'
      const message = payload.message || payload.msg || ''
      this.showModal(title, message)
    })
    request.setErrorHandler((err) => {
      if (!err) return
      const code = err.code
      if (code === 152 || code === '152') {
        this.showModal('未登录', err.message || '未登录或登录已过期')
        return
      }
      this.showModal('提示', err.message || '请求失败，请稍后重试。')
    })
    this.fetchLoginStatus()
    this.loadCurrentSectionData()
  },
  methods: {
    showToast (message, type) {
      const msg = message || ''
      if (!msg) return
      if (this.toast.timer) {
        clearTimeout(this.toast.timer)
        this.toast.timer = null
      }
      this.toast.message = msg
      this.toast.type = type === 'error' ? 'error' : 'success'
      this.toast.visible = true
      this.toast.timer = setTimeout(() => {
        this.toast.visible = false
        this.toast.timer = null
      }, 1500)
    },
    handleNav (section) {
      const path = SECTION_TO_PATH[section] || DEFAULT_PATH
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      this.currentSection = section
    },
    showModal (title, message, options) {
      var opts = options || {}
      this.modal = {
        visible: true,
        title: title || '',
        message: message || '',
        onConfirm: typeof opts.onConfirm === 'function' ? opts.onConfirm : null
      }
    },
    closeModal () {
      this.modal = { visible: false, title: '', message: '', onConfirm: null }
    },
    handleModalConfirm () {
      var fn = this.modal.onConfirm
      this.closeModal()
      if (typeof fn === 'function') {
        fn()
      }
    },
    async handleSaveWorkEdit (payload) {
      const p = payload || {}
      const taskId = p.taskId != null ? String(p.taskId).trim() : ''
      const workName = p.workName != null ? String(p.workName).trim() : ''
      const intro = p.intro != null ? String(p.intro) : ''
      const content = p.content != null ? String(p.content) : ''
      const introList = intro
      if (!taskId) {
        this.showModal('提示', '缺少 taskId，无法保存。')
        return
      }
      if (!workName) {
        this.showModal('提示', '作品名称不能为空。')
        return
      }
      try {
        await updateWorkTask({
          taskId,
          workName,
          introList,
          content
        })
        this.showModal('提示', '保存成功。')
        if (this.$refs.myNovels && typeof this.$refs.myNovels.fetchNovels === 'function') {
          this.$refs.myNovels.fetchNovels(this.$refs.myNovels.currentPage)
        }
      } catch (err) {
        this.showModal('保存失败', (err && err.message) || '保存失败，请稍后重试。')
      }
    },
    showPayModal (title, message, payload) {
      this.payModal = { visible: true, title, message, payload: payload || null }
    },
    handleLoginClick () {
      const basePath = process.env.BASE_URL || '/'
      const redirectUrl = 'https://ai.jianshu.com' + basePath
      const loginUrl = 'https://www.jianshu.com/sign_in?redirect_url=' + encodeURIComponent(redirectUrl)
      window.location.href = loginUrl
    },
    async copyContent (text) {
      var str = ''
      if (typeof text === 'string') {
        str = text
      } else if (text && typeof text === 'object' && (text.workName != null || text.introList != null || text.shortNovelContent != null)) {
        var workName = text.workName != null ? String(text.workName) : ''
        var intro = text.introList != null ? String(text.introList) : ''
        var content = text.shortNovelContent != null ? String(text.shortNovelContent) : ''
        str = '作品名称：' + workName + '\n\n导语推荐：\n' + intro + '\n\n小说内容：\n' + content
      } else if (text && text.textContent) {
        str = text.textContent
      }
      try {
        await copyText(str)
        this.showToast('已复制到剪贴板', 'success')
      } catch (err) {
        this.showToast((err && err.message) || '复制失败，请稍后重试。', 'error')
      }
    },
    openFullContent (title, time, body) {
      this.fullContent = { visible: true, title, time, body }
    },
    handleViewAllOpenFull (payload) {
      if (!payload || typeof payload !== 'object') return
      this.openFullContent(payload.title, payload.time, payload.body)
    },
    async openViewAll (type) {
      const typeNames = { 'short-novel': '我的短篇小说', 'long-novel': '我的长篇小说', 'core-idea': '我的核心梗提取', 'outline': '我的大纲提取' }
      const typeCodes = { 'short-novel': '1', 'long-novel': '2', 'core-idea': '3', 'outline': '4' }
      this.viewAll.visible = true
      this.viewAll.type = type
      this.viewAll.typeName = typeNames[type] || '我的作品'
      this.viewAll.currentPage = 1
      this.viewAll.works = []
      this.viewAll.hasMore = false
      try {
        const res = await getMemberWorkList(typeCodes[type] || '1', 1, this.viewAll.pageSize)
        const list = res && Array.isArray(res.list) ? res.list : []
        const total = res && typeof res.total === 'number' ? res.total : list.length
        this.viewAll.works = list
        this.viewAll.hasMore = 1 * this.viewAll.pageSize < total
      } catch (err) {}
    },
    async viewAllChangePage (page) {
      if (page < 1) return
      if (!this.viewAll.hasMore && page > this.viewAll.currentPage) return
      const typeCodes = { 'short-novel': '1', 'long-novel': '2', 'core-idea': '3', 'outline': '4' }
      this.viewAll.currentPage = page
      try {
        const res = await getMemberWorkList(typeCodes[this.viewAll.type] || '1', page, this.viewAll.pageSize)
        const list = res && Array.isArray(res.list) ? res.list : []
        const total = res && typeof res.total === 'number' ? res.total : list.length
        this.viewAll.works = list
        this.viewAll.hasMore = page * this.viewAll.pageSize < total
      } catch (err) {}
    },
    handleLogout () {
      if (!confirm('确定要退出登录吗？')) return
      document.cookie = 'sessionid=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
      setAuthState({ isLoggedIn: false, balancePoints: 0, nickname: '', avatar: '' })
      this.currentSection = 'short-novel'
      this.$router.push(DEFAULT_PATH)
      this.showModal('退出成功', '您已成功退出登录！')
    },
    async handleCancelAccount () {
      if (!confirm('确定要注销账户吗？注销后无法恢复。')) return
      try {
        await cancelAccount()
        this.cancelAccountResult = {
          visible: true,
          message: '账户已注销，点击确定刷新页面。'
        }
      } catch (err) {
        this.showModal('注销失败', (err && err.message) || '请求失败，请稍后重试。')
      }
    },
    async handleSubmitFeedback () {
      if (!this.feedbackType) {
        this.showModal('提示', '请选择问题类型')
        return
      }
      if (!this.feedbackDesc || !this.feedbackDesc.trim()) {
        this.showModal('提示', '请填写问题描述')
        return
      }
      if (this.feedbackLoading) return
      this.feedbackLoading = true
      try {
        await submitFeedback({
          type: this.feedbackType,
          desc: this.feedbackDesc.trim(),
          contact: this.feedbackContact.trim()
        })
        this.feedbackLoading = false
        this.feedbackOpen = false
        this.feedbackType = ''
        this.feedbackDesc = ''
        this.feedbackContact = ''
        this.showModal('提交成功', '感谢您的反馈，我们会尽快处理！')
      } catch (err) {
        this.feedbackLoading = false
        this.showModal('提交失败', (err && err.message) || '网络异常，请稍后重试。')
      }
    },
    async handlePay () {
      if (this.payLoading) return
      this.payLoading = true
      const payload = (this.payModal && this.payModal.payload) || {}
      try {
        const data = await goPay(payload)
        this.payLoading = false
        this.payModal.visible = false
        this.payResultOrderNo = (data && data.orderNo != null) ? String(data.orderNo) : ''
        const normalizedType = (data && data.type != null) ? String(data.type).trim().toLowerCase() : ''
        this.payType = normalizedType

        if (normalizedType === 'alipay' || normalizedType === 'ali_pay' || normalizedType === 'ali-pay') {
          this.payResultModal = {
            visible: true,
            title: '支付提示',
            message: '请确认是否已经在支付页面完成付款。\n如已完成，请点击下方"已经支付成功"。'
          }
        }
        if (normalizedType === 'wechat' || normalizedType === 'wechatpay' || normalizedType === 'wechat_pay' || normalizedType === 'wechat-pay') {
          this.wechatCodeQrDataUrl = (data && data.path != null) ? String(data.path) : ''
          this.payResultModal = {
            visible: true,
            title: '微信支付',
            message: '请使用微信扫码完成支付。'
          }
          if (this.wechatCodeQrDataUrl) {
            const url = await QRCode.toDataURL(this.wechatCodeQrDataUrl, { width: 200, margin: 1 })
            this.wechatCodeQrDataUrl = url || ''
          }
        }

        if (data && (data.show === true || data.show === 'true')) {
          this.memberPlanModal.visible = true
          this.memberPlanModal.userExpireDate = data.userExpireDate || ''
          this.memberPlanModal.toBugExpireDate = data.toBugExpireDate || ''
        }
      } catch (err) {
        this.payLoading = false
        this.payModal.visible = false
        this.showModal('下单失败', (err && err.message) || '下单失败')
      }
    },
    closePayResultModal () {
      this.payResultModal.visible = false
      this.wechatCodeQrDataUrl = ''
      this.payResultOrderNo = ''
      this.payType = ''
    },
    async handlePayResultConfirm () {
      if (this.payResultLoading) return
      this.payResultLoading = true
      try {
        const data = await queryPayStatus(this.payResultOrderNo, this.payType)
        this.payResultLoading = false
        const ok = data && data === 'TRADE_SUCCESS'
        if (ok) {
          this.closePayResultModal()
          location.reload()
        } else {
          this.payResultModal.message = '尚未支付成功，请完成支付后重试。'
        }
      } catch (err) {
        this.payResultLoading = false
        this.payResultModal.message = '尚未支付成功，请完成支付后重试。'
      }
    },
    async fetchLoginStatus () {
      try {
        const result = await checkLogin()
        var nick = ''
        var av = ''
        if (result && result.user) {
          if (result.user.nickname != null) nick = String(result.user.nickname)
          av = pickUserAvatarUrl(result.user)
        }
        setAuthState({
          isLoggedIn: result.loggedIn === true,
          balancePoints: result.balancePoints != null ? result.balancePoints : 0,
          nickname: result.loggedIn === true ? nick : '',
          avatar: result.loggedIn === true ? av : ''
        })
      } finally {
        resolveLoginGate()
      }
    },
    loadCurrentSectionData () {
    }
  }
}
</script>
